import { Button, Dialog } from '@ui'
import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { HiMiniExclamationTriangle } from 'react-icons/hi2'

interface Props {
  visible?: boolean
  title?: string
  description?: string
  onDismiss?: () => void
}

const ErrorPopup: FC<Props> = ({ visible, title, description, onDismiss }) => {
  const { t } = useTranslation()

  return (
    <Dialog
      open={!!visible}
      onClose={onDismiss}
      title={title}
      description={description}
      icon={
        <span className="grid size-12 place-items-center rounded-full bg-warning-bg text-[26px] text-warning">
          <HiMiniExclamationTriangle />
        </span>
      }
      actions={
        <Button fullWidth onClick={onDismiss}>
          {t('common.understood')}
        </Button>
      }
    />
  )
}

export default ErrorPopup
